/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type HumidityBadge_DisplayFragment = { __typename: 'Display', id: string, humidity?: Array<{ __typename: 'Humidity', isSensorPresent: boolean, value: string, updatedAt?: string | null }> | null };

export const HumidityBadge_DisplayFragmentDoc = gql`
    fragment HumidityBadge_display on Display {
  id
  humidity {
    isSensorPresent
    value
    updatedAt
  }
}
    `;